module.exports = __webpack_public_path__ + "static/img/11.990881c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/11.png
// module id = KDgg
// module chunks = 35